<template>
	<div class="bg-white all margin-left">
		<div class="flex align-center justify-start toptitle">
			<p class="txt28">增值税普通发票</p>
			<p class="status margin-left unpay">已开票</p>
		</div>
		<div class="padding-top-sm">
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">发票抬头</div>
				<div class="fu-fs26 text-333">企业</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">开票对象</div>
				<div class="fu-fs26 text-333">某某某某某公司</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">统一社会信用编码</div>
				<div class="fu-fs26 text-333">105451212451</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">发票内容</div>
				<div class="fu-fs26 text-333">外包服务</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">发票金额</div>
				<div class="fu-fs26 text-theme">258元</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">开户行</div>
				<div class="fu-fs26 text-333">建行朝阳门支行</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">开户行账号</div>
				<div class="fu-fs26 text-333">2454545214545124</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">注册电话</div>
				<div class="fu-fs26 text-333">010-5454541</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">注册地址</div>
				<div class="fu-fs26 text-333">北京朝阳区望京SOHO塔一期-06</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">发票类型</div>
				<div class="fu-fs26 text-333">增值税专用发票（纸质版</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">收件地址</div>
				<div class="fu-fs26 text-333">北京朝阳区望京</div>
			</div>
			<div class="flex align-start per_row_box">
				<div class="fu-fs26 text-999 title">联系方式</div>
				<div class="fu-fs26 text-333">645849684651</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.txt28{
		font-size: 28px;
	}
	.all{
		width: 921px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
	}
	.toptitle{
		border-bottom: 1px solid #E6E6E8;
		padding: 40px 0 30px 60px;
	}
	.per_row_box{
		height: 40px;
		padding-left: 60px;
		.title{
			width: 146px;
			text-align: left;
		}
	}
	.status{
		width: 64px;
		height: 29px;
		line-height: 29px;
		border-radius: 0px 20px 0px 10px;
	}
	.unpay{
		background: rgba(120,147,255,0.1000);
		color: #568EEB;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/receipt/detail.vue